export default function authHeader() {
    try {
        const authUser = JSON.parse(sessionStorage.getItem("authTokenData"));

        if (authUser) {
            return {Authorization: `Bearer ${authUser}`};
        } else {
            return {};
        }
    } catch (error) {
        console.error("Error in authHeader:", error);
        return {};
    }
}
